var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "notification",
    {
      staticClass: "confirm-email-notification",
      attrs: { "is-show-icon": false, type: "warning" }
    },
    [
      _c("p", { staticClass: "confirm-email-notification__desc" }, [
        _vm._v("\n    Подтвердите свой email и получите еще\n    "),
        _c("strong", [_vm._v("50 бонусных рублей")]),
        _vm._v(".\n  ")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "confirm-email-notification__desc" }, [
        _vm._v("\n    Проверьте свою почту, мы отправили вам письмо.\n  ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }